var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIconDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8493 11.8014L17.1997 10.1517L6.33333 21.0181V22.6677H7.983L18.8493 11.8014ZM20.499 10.1517L22.1487 8.50207L20.499 6.85241L18.8493 8.50207L20.499 10.1517ZM8.949 25.0011H4V20.0509L19.6742 4.37674C19.8929 4.15802 20.1896 4.03516 20.499 4.03516C20.8084 4.03516 21.1051 4.15802 21.3238 4.37674L24.6243 7.67724C24.843 7.89602 24.9659 8.19272 24.9659 8.50207C24.9659 8.81143 24.843 9.10812 24.6243 9.32691L8.95017 25.0011H8.949Z",
    fill: "#7F7F7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconDisabled);
export default __webpack_public_path__ + "static/media/edit-icon-disabled.bc496bb57f7c84c0b31a2c4f0379d902.svg";
export { ForwardRef as ReactComponent };